import React from "react";
import previewIcon from "assets/illustrations/gymo_app_preview.png";
import gymoIcon from "assets/icons/gymo_logo_with_lettering.png";
import { useLocation } from "react-router-dom";
import Headline from "components/text.components/headline.component/headline.component";
import { RunningText } from "components/text.components/running.text.component/running.text.component";
import Column from "components/general.compoenents/column.component/column.component";
import OutlinedTextInput from "components/input.components/outlined.text.input.component/outlined.text.input.component";
import SizedContainer from "components/general.compoenents/sized.container.component/sized.container.component";
import { ContainerSizes } from "globals/enums/global.enum";
import FilledButton from "components/input.components/filled.button.component/filled.button.component";
import { useForm } from "react-hook-form";
import { HttpAuthService } from "services/httpClients/http.auth.client";
import { toast } from "react-toastify";
import { getEmailValidationPattern } from "globals/helpers/validation.helper";
import { Logging } from "globals/helpers/logging.helper";
import Row from "components/general.compoenents/row.component/row.component";
import "./forgot.password.page.scss";

const ForgotPasswordPage = (): JSX.Element => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const params = new URLSearchParams(location.search);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleForgotPassword = async (data: any): Promise<void> => {
    try {
      const response = await HttpAuthService.getInstance().handleForgotPassword(
        { email: data.email }
      );

      if (response) {
        toast.success("Email wurde erfolgreich versendet");
      }
    } catch (err) {
      Logging.error({
        className: "ForgotPasswordPage",
        methodName: "handleForgotPassword",
        message: "Email konnte nicht versendet werden",
        exception: err,
        showAlert: true,
      });
    }
  };

  const _buildForgotPasswordContent = (): JSX.Element => {
    return (
      <div className="forgot-password-form-container">
        <div className="forgot-password-form-wrapper">
          <form
            className="forgot-password-form"
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onSubmit={handleSubmit(handleForgotPassword, (errors) => {
              toast.error("Bitte überprüfe deine Eingaben");
            })}
            noValidate
          >
            <SizedContainer size={ContainerSizes.L}>
              <Column alignItems="flex-start">
                <Headline className="mb-15">
                  Hey! Du hast dein Passwort vergessen? Kein Problem!
                </Headline>
                <RunningText className="mb-20">
                  Gib deine Email-Adresse ein und wir senden dir einen Link zum
                  Zurücksetzen deines Passworts.
                </RunningText>
                <OutlinedTextInput
                  label="Email"
                  type="email"
                  inputRef={register("email", {
                    required: "Email is required",
                    pattern: {
                      value: getEmailValidationPattern(),
                      message: "Please enter a valid email",
                    },
                  })}
                  validationMessage={errors.email?.message?.toString()}
                />
                <FilledButton
                  label="Email senden"
                  className="mt-15 full-width"
                  type="submit"
                />
              </Column>
            </SizedContainer>
          </form>
        </div>
      </div>
    );
  };

  const _buildPreview = (): JSX.Element => {
    return (
      <div className="forgot-password-preview-container">
        <img className="gymo-logo" src={gymoIcon} />
        <Headline className="forgot-password-header">{`The biggest smallest\nFitness Software.`}</Headline>
        <img className="forgot-password-preview-image" src={previewIcon} />
      </div>
    );
  };

  return (
    <Row className="forgot-password-page">
      <div className="forgot-password-page-wrapper">
        {_buildPreview()}
        <div className="forgot-password-form-wrapper">
          {_buildForgotPasswordContent()}
        </div>
      </div>
    </Row>
  );
};

export default ForgotPasswordPage;
